export * from '@primeuix/themes/material/card';
export { default } from '@primeuix/themes/material/card';
